import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loaderStatus: false,
  banners: [],
  menuItems: [],
  tables: [],
  menuCategories: [],
  restaurantInfo: null,
};

const menuSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    setLoaderStatus: (state, action) => {
      state.loaderStatus = action.payload;
    },
    setRestaurantInfo: (state, action) => {
      state.restaurantInfo = action.payload;
    },
    setBanners: (state, action) => {
      state.banners = action.payload;
    },
    setMenuItems: (state, action) => {
      state.menuItems = action.payload;
    },
    setTables: (state, action) => {
      state.tables = action.payload;
    },
    setMenuCategories: (state, action) => {
      state.menuCategories = action.payload;
    },
  },
});

export const {
  setLoaderStatus,
  setRestaurantInfo,
  setBanners,
  setMenuItems,
  setTables,
  setMenuCategories,
} = menuSlice.actions;

export default menuSlice.reducer;
